import { render, staticRenderFns } from "./StepperButtons.vue?vue&type=template&id=2dcb0d0a&scoped=true&"
import script from "./StepperButtons.vue?vue&type=script&lang=ts&"
export * from "./StepperButtons.vue?vue&type=script&lang=ts&"
import style0 from "./StepperButtons.vue?vue&type=style&index=0&id=2dcb0d0a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcb0d0a",
  null
  
)

export default component.exports